/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Models_DisclaimerInputs */

const en_directory_models_disclaimer = /** @type {(inputs: Directory_Models_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing and capabilities change frequently and are shown for reference only — always verify with the provider.`)
};

const zh_directory_models_disclaimer = /** @type {(inputs: Directory_Models_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定价与能力变动频繁，仅供参考，请以官方信息为准。`)
};

/**
* | output |
* | --- |
* | "Pricing and capabilities change frequently and are shown for reference only — always verify with the provider." |
*
* @param {Directory_Models_DisclaimerInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_models_disclaimer = /** @type {((inputs?: Directory_Models_DisclaimerInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Models_DisclaimerInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_models_disclaimer(inputs)
	return zh_directory_models_disclaimer(inputs)
});
export { directory_models_disclaimer as "directory.models.disclaimer" }